<div *ngFor="let alert of successes">
  <kmd-alerts kmd-success [icon]="true" [floating]="true" [show]="true" [alertText]="alert.message" [dismissible]="true" 
    (closed)="successAlertClosed(alert.id)"></kmd-alerts>
</div>

<div *ngFor="let alert of warnings">
  <kmd-alerts kmd-warning [icon]="true" [floating]="true" [show]="true" [alertText]="alert.message" [dismissible]="true" 
    (closed)="warningAlertClosed(alert.id)"></kmd-alerts>
</div>

<div *ngFor="let alert of errors">
  <kmd-alerts kmd-error [icon]="true" [floating]="true" [show]="true" [alertText]="alert.message" [dismissible]="true" 
    (closed)="errorAlertClosed(alert.id)"></kmd-alerts>
</div>